module.exports = __webpack_public_path__ + "img/page-ico.3338dc4d.png";